
import {ChainId, JSBI, Percent, Token, CurrencyAmount, Currency, ETHER} from '@pancakeswap/sdk'
import {TokenAddressMap} from '../state/lists/hooks'

import {getRouterAddress} from './addressHelpers'
import {LBRouterABI, LBRouterV21ABI, LB_ROUTER_ADDRESS} from '~/v3sdk'
import {LB_ROUTER_V21_ADDRESS} from '~/v3sdk/constants'
import {BLOCK_EXPLORER_CHAIN_MAP, VIEM_CHAINS} from "~/config/constants/chains";
import { memoize } from 'lodash'
import { Address, getAddress } from 'viem'
import { getContract } from './contractHelpers'

// returns the checksummed address if the address is valid, otherwise returns undefined
export const safeGetAddress = memoize((value: any): Address | undefined => {
  try {
    let value_ = value
    if (typeof value === 'string' && !value.startsWith('0x')) {
      value_ = `0x${value}`
    }
    return getAddress(value_)
  } catch {
    return undefined
  }
})


// returns the checksummed address if the address is valid, otherwise returns false
export function isAddress(value: any): string | false {
  try {
    return getAddress(value)
  } catch {
    return false
  }
}

export function getBscScanLink(
  data: string | number,
  type: 'transaction' | 'token' | 'address' | 'block' | 'countdown',
  chainId: ChainId = ChainId.MAINNET,
): string {

  switch (type) {
    case 'transaction': {
      return `${BLOCK_EXPLORER_CHAIN_MAP[chainId]}/tx/${data}`
    }
    case 'token': {
      return `${BLOCK_EXPLORER_CHAIN_MAP[chainId]}/token/${data}`
    }
    case 'block': {
      return `${BLOCK_EXPLORER_CHAIN_MAP[chainId]}/block/${data}`
    }
    case 'countdown': {
      return `${BLOCK_EXPLORER_CHAIN_MAP[chainId]}/block/countdown/${data}`
    }
    default: {
      return `${BLOCK_EXPLORER_CHAIN_MAP[chainId]}/address/${data}`
    }
  }
}

export function getBscScanLinkForNft(
  collectionAddress: string,
  tokenId: string,
  chainId: ChainId = ChainId.MAINNET,
): string {
  return `${BLOCK_EXPLORER_CHAIN_MAP[chainId]}/token/${collectionAddress}?a=${tokenId}`
}

// add 10%
export function calculateGasMargin(value: bigint, margin = 1000n): bigint {
  return (value * (10000n + margin)) / 10000n
}

// converts a basis points value to a sdk percent
export function basisPointsToPercent(num: number): Percent {
  return new Percent(JSBI.BigInt(num), JSBI.BigInt(10000))
}


export function calculateSlippageAmount(value: CurrencyAmount, slippage: number): [JSBI, JSBI] {
  if (slippage < 0 || slippage > 10000) {
    throw Error(`Unexpected slippage value: ${slippage}`)
  }
  return [
    JSBI.divide(JSBI.multiply(value.raw, JSBI.BigInt(10000 - slippage)), JSBI.BigInt(10000)),
    JSBI.divide(JSBI.multiply(value.raw, JSBI.BigInt(10000 + slippage)), JSBI.BigInt(10000)),
  ]
}


// account is not optional
// export function getSigner(library: Web3Provider | JsonRpcProvider, account: string): JsonRpcSigner {
//   return library.getSigner(account).connectUnchecked()
// }

// // account is optional
// export function getProviderOrSigner(library: Web3Provider | JsonRpcProvider, account?: string): Web3Provider | JsonRpcProvider | JsonRpcSigner {
//   return account ? getSigner(library, account) : library
// }

// // account is optional
// export function getContract(address: string, ABI: any, library: Web3Provider | JsonRpcProvider, account?: string): Contract {
//   if (!isAddress(address) || address === AddressZero) {
//     throw Error(`Invalid 'address' parameter '${address}'.`)
//   }

//   return new Contract(address, ABI, getProviderOrSigner(library, account) as any)
// }

// account is optional
export function getRouterContract(_: number, library: any, account?: string): Contract {

  throw new Error("Uuuuups")
  // const chainId = library.network?.chainId
  // return getContract(getRouterAddress(chainId), IUniswapV2Router02ABI, library, account)
}

export function getRouterV2Contract(chainId: number, library: any, isV21: boolean, account?: string): Contract {
  throw new Error("Uuuuups")
  // return getContract(
  //   isV21 ? LB_ROUTER_V21_ADDRESS[chainId] : LB_ROUTER_ADDRESS[chainId],
  //   isV21 ? LBRouterV21ABI : LBRouterABI, library, account)
}

export function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}

export function isTokenOnList(defaultTokens: TokenAddressMap, currency?: Currency): boolean {
  if (currency === ETHER) return true
  return Boolean(currency instanceof Token && defaultTokens[currency.chainId]?.[currency.address])
}


export function urlChainId(chainId: number): string {
  return `:${chainId}`
}

export function deurlChainId(urlparam: string): number {
  return parseFloat(urlparam.replace(":", ""))
}

export async function waitMs(ms: number): Promise<void> {
  return await new Promise(res => setTimeout(res, ms))
}
